/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['article-modal.modal .modal-content{width:1000px;box-shadow:none;border:1px solid #e0e0e0;border-radius:4px;overflow:auto}article-modal.modal .scroll-container{overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvc2hhcmVkL2FydGljbGUtbW9kYWwvYXJ0aWNsZS1tb2RhbC5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9zaGFyZWQvYXJ0aWNsZS1tb2RhbC9hcnRpY2xlLW1vZGFsLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/help-center/shared/article-modal/article-modal.component.scss.ngstyle.ts